import { AppServerErrorModel } from "../../model"

export class AppNeedPayError extends Error {
    errData: AppServerErrorModel

    constructor(data: AppServerErrorModel) {
        super(data.message)

        this.errData = data
    }
}